import { UPDATE_FILTER, RESET_FILTER } from "./mapFilterTrackersReducer"

export const updateFilter = (feature) => ({
    type: UPDATE_FILTER,
    payload: feature
})

export const resetFilter = () => ({
    type: RESET_FILTER,
})